import ST03001Animation from '../animations/ST03-001';

const animationsDict = {
    'ST03-001': ST03001Animation,
};

export async function playAnimation(scene, animationDetails) {
    const { gameState } = animationDetails;
    const { animation } = gameState.pendingAction.currentStepData.details;

    await animationsDict[animation]?.(scene, gameState);
}